@if (deviceGroupView$ | async; as view) {
  <app-card class="link" (click)="onDetails()">
    <div class="header">
      <div>
        <div class="flex">
          <h3 class="line-clamp">
            <app-text-with-icon name="ic_device_group">{{
              view.deviceGroup.name
            }}</app-text-with-icon>
          </h3>
          @if (view.deviceGroup.isFavorite && !hideFavoriteIcon) {
            <app-icon class="color-favorite" name="ic_star_filled" />
          }
        </div>
        <div class="flex gap-2 ml-2">
          @if (view.deviceCount) {
            <p>
              {{ view.deviceCount }}
              {{ "deviceGroups.devices" | translate }}
            </p>
          }
        </div>
      </div>

      <div class="flex">
        <app-tag>
          {{
            LabelConverter.getDeviceGroupStateLabel(view.deviceGroup.state)
              | translate
                : (view.deviceGroup.state === "PARTIALLY_ACTIVE"
                    ? {
                        activeCount: view.activeDeviceCount,
                        count: view.deviceCount,
                      }
                    : {})
          }}
        </app-tag>
        @if (!hideActions) {
          <button
            type="button"
            class="button icon-button"
            (click)="onToggleExpanded($event)"
          >
            @if (isExpanded) {
              <app-icon name="ic_chevron_up" />
            } @else {
              <app-icon name="ic_chevron_down" />
            }
          </button>
          <app-context-menu [menuItems]="contextMenu" />
        }
      </div>
    </div>

    @if (isExpanded) {
      <div class="content">
        <div class="flex column">
          @for (device of view.devices; track device.id) {
            <app-device-item-card
              class="w-full"
              [device]="device"
              [disabled]="true"
              [hideActions]="true"
            />
          }
        </div>
      </div>
    }
  </app-card>
}
